{
  "id": "esocial",
  "nome": "eSocial S-1.3 — Tabela 01 (Categorias) + Tabela 03 (Rubricas)",
  "fonte": "eSocial S-1.3 — Tabelas 01 e 03",
  "endpoints": [
    "https://www.gov.br/esocial/pt-br/documentacao-tecnica/leiautes-esocial-versao-s-1-3-nt-06-2026/tabelas.html"
  ],
  "capturadoEm": "2026-06-27",
  "atualizadoEm": "2026-06-27T15:22:50.157Z",
  "contagens": {
    "categorias": 47,
    "rubricas": 208
  },
  "alteracoes": {
    "adicionados": 208,
    "removidos": 0,
    "alterados": 0,
    "comparadoCom": "2026-06-25"
  },
  "verificacao": {
    "agendamento": "manual",
    "workflow": "data-refresh-bot.yml",
    "ultimaExecucao": "2026-06-27T15:22:50.157Z"
  },
  "documentacao": "docs/OFFICIAL-SOURCES.md#esocial"
}
